import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import SearchAppointment from 'app/containers/CustomerCare/SearchAppointment'

const SearchAppointmentCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.customer_care_plan)}</PageTitle>
      <SearchAppointment />
    </>
  )
}
const SearchAppointmentPage = memo(SearchAppointmentCpn, isEqual)

export default SearchAppointmentPage
